





































import { Component, Prop, Vue } from "vue-property-decorator";
import i18n from "@/i18n";

@Component
export default class UFormControls extends Vue {
  // Props

  @Prop({ default: true })
  public isSticky!: boolean;

  @Prop({ default: true })
  public isEnabled!: boolean;

  @Prop({ default: false })
  public isProcessing!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public revertIsDisabled!: boolean;

  @Prop({ default: () => i18n.t("_action.save") })
  public saveText!: string;

  @Prop({ default: () => i18n.t("_action.revert_changes") })
  public revertText!: string;
}
